import { styled } from '@mui/material/styles';

export const Video = styled('video')`
  height: ${({ height }) => (height ? `${height}px` : '32rem')};
  min-height: 18rem;
  max-height: 48rem;
  border-radius: 0.8rem;
  cursor: pointer;
`;
